export const ProgramsActions = {
    GET_PROGRAMS: "GET_PROGRAMS",
    SET_PROGRAMS: "SET_PROGRAMS",
  };

  